export default __webpack_public_path__ + "static/media/pop-close.27264fdd.png";